import { render, staticRenderFns } from "./Layouts.vue?vue&type=template&id=0e2f1f20&scoped=true"
import script from "./Layouts.vue?vue&type=script&lang=js"
export * from "./Layouts.vue?vue&type=script&lang=js"
import style0 from "./Layouts.vue?vue&type=style&index=0&id=0e2f1f20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2f1f20",
  null
  
)

export default component.exports